/** Ce mașină stă pe un loc de parcare de suprafață: dacă e ocupat, ce
 *  variantă și ce nuanță. Aceeași alegere pentru planul 2D și pentru machetă,
 *  deci un loc are aceeași mașină în amândouă.
 *
 *  Pur, fără three.js: planșa 2D îl importă și nu trebuie să tragă după ea
 *  randorul (ca `verdeLot.ts`). */

/** Nuanțele: albe și gri, fără culoare — macheta e una de prezentare, iar o
 *  mașină colorată trage ochiul de la clădire. Griul închis e rar (v.
 *  ponderile), cât să rupă monotonia unui rând, nu să-l coloreze. */
export const PALETA_MASINI = ["#f4f4f1", "#ece8e1", "#dadad7", "#bfc1c2", "#8f9296"] as const;
const PONDERI_PALETA = [0.30, 0.24, 0.20, 0.14, 0.12];

/** Câte locuri au mașină pe machetă. Sub 1, ca parcajul să nu pară depozit;
 *  golurile vin din poziție, nu dintr-un tipar care se vede pe rând. */
export const OCUPARE = 0.75;

/** Un număr în [0, 1), stabil pentru o poziție: aceeași soluție arată mereu
 *  aceleași mașini în aceleași locuri, la fiecare încărcare. */
export function hashLoc(x: number, y: number, sare = 0): number {
  const s = Math.sin(x * 12.9898 + y * 78.233 + sare * 37.719) * 43758.5453;
  return s - Math.floor(s);
}

export const locOcupat = (x: number, y: number) => hashLoc(x, y, 1) < OCUPARE;

/** Indicele variantei (0 … n-1) pentru un loc. */
export const variantaLoc = (x: number, y: number, n: number) =>
  Math.min(n - 1, Math.floor(hashLoc(x, y, 2) * n));

export function culoareMasina(x: number, y: number): string {
  let h = hashLoc(x, y, 3);
  for (let k = 0; k < PALETA_MASINI.length; k++) {
    h -= PONDERI_PALETA[k];
    if (h < 0) return PALETA_MASINI[k];
  }
  return PALETA_MASINI[0];
}

/** Liniile desenului pe o mașină: gri, nu negre, ca mașina să rămână un obiect
 *  ușor pe planșă; pe griul închis, mai închise, ca să se vadă. */
export function liniiMasina(fill: string): { contur: string; geam: string } {
  return fill === PALETA_MASINI[PALETA_MASINI.length - 1]
    ? { contur: "#3e4144", geam: "#6d7176" }
    : { contur: "#8d9094", geam: "#a9adb2" };
}
